import constants from '../constants';

const setOvertimeSlicer = async (reportParameters, visuals) => {
  await setDateSlicerVisual(reportParameters, visuals);
};

const setDateSlicerVisual = async (reportParameters, visuals) => {
  try {
    const StartDate = new Date(reportParameters.StartDate);
    const EndDate = new Date(reportParameters.EndDate);

    const dateSlicerFilter = {
      $schema: constants.ADVANCED_FILTER,
      target: {
        table: 'vwUtilityERCOTDemandLoads',
        column: 'SiteDateTime',
      },
      logicalOperator: 'And',
      conditions: [
        {
          operator: 'GreaterThanOrEqual',
          value: StartDate.toISOString(),
        },
        {
          operator: 'LessThanOrEqual',
          value: EndDate.toISOString(),
        },
      ],
    };
    const dateSlicerVisual = visuals.filter((visual) => {
      return visual.type === 'slicer' && visual.title === 'Date Slicer';
    })[0];

    await dateSlicerVisual.setSlicerState({ filters: [dateSlicerFilter] });

  } catch (error) {
    return Promise.reject(error);
  }
};

export default {
  setOvertimeSlicer
};
